<template>
  <div>
    <TopHeader code="app" />

    <section class="uc-banner151"></section>

    <section class="container-fluid g-centerTabSearch">
      <div class="container">
        <div class="row">
          <div class="col-24 filter">
            <div class="menu-tab">
              <div
                :class="tab == 'tab1' ? 'item on' : 'item'"
                @click="
                  tab = 'tab1';
                  loadData();
                "
              >
                全部商品
              </div>
              <div
                :class="tab == 'tab2' ? 'item on' : 'item'"
                @click="
                  tab = 'tab2';
                  loadData();
                "
              >
                我可兑换
              </div>
            </div>
            <div class="search">
              <input
                type="text"
                placeholder="请输入搜索关键字"
                class="uc-input"
                v-model="keyword"
                @keyup.enter="loadData"
              />
              <a class="uc-btn blue" @click="loadData"
                ><i class="uc-font uc-search"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="tab == 'tab1'">
      <section class="container-fluid uc-scoreMallList">
        <div class="container">
          <div class="content-empty" v-if="list.total_count == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>
          <div class="row">
            <div
              v-for="(item, index) in list.items"
              :key="index"
              class="col-6 box"
            >
              <div class="item">
                <div class="img img-box">
                  <router-link to="">
                    <el-image :src="item.img_url">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-sp.png" />
                      </div>
                    </el-image>
                  </router-link>
                </div>
                <div class="con">
                  <h3>{{ item.name }}</h3>
                  <div class="score">
                    <span class="big">{{ item.score }}</span> 积分
                  </div>
                  <div class="txt">
                    {{ item.description }}
                  </div>
                  <a
                    href="javascript:;"
                    @click="handleExchange(item)"
                    class="uc-btn blue"
                    >立即兑换</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-24">
              <el-pagination
                class="uc-prvNxt"
                background
                layout="prev, pager, next"
                hide-on-single-page
                :current-page="query.pageIndex"
                :page-size="query.pageSize"
                :total="list.total_count"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-if="tab == 'tab2'">
      <section class="container-fluid uc-scoreMallList">
        <div class="container">
          <div class="content-empty" v-if="listCan.total_count == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>
          <div class="row">
            <div
              v-for="(item, index) in listCan.items"
              :key="index"
              class="col-6 box"
            >
              <div class="item">
                <div class="img">
                  <router-link to="">
                    <img :src="item.img_url" />
                  </router-link>
                </div>
                <div class="con">
                  <h3>{{ item.name }}</h3>
                  <div class="score">
                    <span class="big">{{ item.score }}</span> 积分
                  </div>
                  <div class="txt">
                    {{ item.description }}
                  </div>
                  <a
                    href="javascript:;"
                    @click="handleExchange(item)"
                    class="uc-btn blue"
                    >立即兑换</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-24">
              <el-pagination
                class="uc-prvNxt"
                background
                layout="prev, pager, next"
                hide-on-single-page
                :current-page="queryCan.pageIndex"
                :page-size="queryCan.pageSize"
                :total="listCan.total_count"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </section>
    </div>

    <el-dialog
      title="兑换商品"
      :visible.sync="dialogFormVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="现有积分" :label-width="formLabelWidth" prop="num">
          <span>{{ modelIngtegral.remainder || 0 }}分</span>
        </el-form-item>
        <el-form-item label="商品库存" :label-width="formLabelWidth" prop="num">
          <span>{{ modelPorduct.count || 0 }}件</span>
        </el-form-item>
        <el-form-item
          label="收货地址"
          prop="address"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="form.address"
            placeholder="请选择收货地址"
            style="width:80%;"
          >
            <el-option
              v-for="(item, index) in addressList.items"
              :key="index"
              :label="
                `${item.province + item.city + item.district + item.address}`
              "
              :value="item.id"
            >
              <span style="float: left">
                {{ item.province + item.city + item.district + item.address }}
              </span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ item.name + ' - ' + item.phone }}
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换数量" :label-width="formLabelWidth" prop="num">
          <el-input-number
            size="small"
            v-model="form.num"
            @change="handleExchangeNumber"
            :min="1"
            :max="modelPorduct.count"
            label="兑换数量"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="所需积分" :label-width="formLabelWidth" prop="num">
          <span>{{ form.productIngtegral }}分</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >立即兑换</el-button
        >
      </div>
    </el-dialog>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'Mall',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: '100px',
      form: {
        productId: 0,
        productIngtegral: 0,
        address: '',
        num: 1,
      },
      rules: {
        address: [
          { required: true, message: '请选择收货地址', trigger: 'blur' },
        ],
      },
      tab: 'tab1',
      keyword: undefined,
      query: {
        pageIndex: 1,
        pageSize: 16,
        keyword: undefined,
      },
      queryCan: {
        pageIndex: 1,
        pageSize: 16,
        keyword: undefined,
      },
      modelPorduct: {
        id: 0,
        name: '',
        score: 0,
        count: 0,
      },
      modelIngtegral: {},
      addressList: {},
      list: {},
      listCan: {},
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getProducts();
    },
    loadData() {
      if (this.tab === 'tab1') {
        this.query.keyword = this.keyword;
        this.getProducts();
      } else if (this.tab === 'tab2') {
        this.queryCan.keyword = this.keyword;
        this.getConvertibleProducts();
      }
    },
    // 全部商品
    async getProducts() {
      const response = await this.$api.integral.getProducts(this.query);
      this.list = response.data.data;
    },
    // 我可兑换商品
    async getConvertibleProducts() {
      const response = await this.$api.integral.getConvertibleProducts(
        this.queryCan
      );
      this.listCan = response.data.data;
    },
    // 兑换
    handleExchange(item) {
      if (item.count < 1 || item.count <= item.times) {
        this.$message.warning('库存不足，无法兑换');
        return;
      }
      if (this.$store.getters.user.statistics.total_integral < item.score) {
        this.$message.warning('您的积分不足，无法兑换');
        return;
      }
      // 兑换产品的订单信息
      this.form.productId = item.id;
      this.form.productIngtegral = item.score;

      // 要兑换的产品信息
      this.modelPorduct.id = item.id;
      this.modelPorduct.name = item.name;
      this.modelPorduct.score = item.score;
      this.modelPorduct.count = item.count;

      // 获取我的收货地址
      this.getMyAddress();
      // 获取我的积分
      this.getMyIngtegral();

      // 显示
      this.dialogFormVisible = true;
    },
    // 调整兑换数量
    handleExchangeNumber(value) {
      this.form.productIngtegral = this.modelPorduct.score * value;
      if (this.form.productIngtegral > this.modelIngtegral.remainder) {
        this.$message.warning('您的积分不足，无法兑换');
        return;
      }
      if (this.form.num > this.modelPorduct.count) {
        this.$message.warning('商品数量不足，无法兑换');
        return;
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      // 清空表单
      this.$refs.form.resetFields();
      // 隐藏
      this.dialogFormVisible = false;
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        product_id: this.form.productId,
        consume_count: this.form.num,
        address_id: this.form.address,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          const consumeScore = this.modelPorduct.score * this.form.num;
          if (consumeScore > this.modelIngtegral.remainder) {
            this.$message.warning('您的积分不足，无法兑换');
            return;
          }
          if (this.form.num > this.modelPorduct.count) {
            this.$message.warning('商品数量不足，无法兑换');
            return;
          }
          // 提交兑换记录
          this.postExchangeProduct(submitData);
        }
      });
    },
    // 翻页
    handleCurrentChange(val) {
      this.tab === 'tab1'
        ? (this.query.pageIndex = val)
        : (this.queryCan.pageIndex = val);
      this.loadData();
    },
    // 获取我的地址
    async getMyAddress() {
      const response = await this.$api.integral.getAddresses({
        pageIndex: 1,
        pageSize: 10,
      });
      this.addressList = response.data.data;
    },
    // 我的积分
    async getMyIngtegral() {
      const response = await this.$api.integral.getMyIngtegral();
      this.modelIngtegral = response.data.data || {};
    },
    // 兑换商品
    async postExchangeProduct(myProduct) {
      const response = await this.$api.integral.exchangeProduct(myProduct);
      if (response.data.code === 200) {
        this.$message.success({
          message: response.data.message,
          // onClose: () => {
          //   window.open('/personal/order');
          // },
        });
        // 关闭弹窗
        this.dialogFormVisible = false;
        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
  },
};
</script>
